const activityTimeFieldTypes = {
  STRING: 'string',
  NUMBER: 'number',
};

module.exports = {
  activityTimeFieldTypes,
};
